<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @shown="focusSearchTerm"
            @hidden="hidden"
            title-class="w-100"
        >
            <template #modal-title>
                <div class="d-flex align-items-center w-100">
                    <div class="mr-3">
                        <div class="d-flex align-items-center w-100 mb-1">
                            <div class="mr-1">
                                Add
                            </div>
                            <div class="text-capitalize">
                                {{filter_type}}
                            </div>
                        </div>
                        <div class="h6 text-muted mb-0">
                            Page {{page.page}}
                        </div>
                    </div>
                    <div class="ml-auto">
                        <b-form-select v-model="filter_type">
                            <b-form-select-option value="article">Article</b-form-select-option>
                            <b-form-select-option value="activity">Activity</b-form-select-option>
                            <b-form-select-option value="rubric">Rubric</b-form-select-option>
                            <b-form-select-option value="walkthrough">Walkthrough</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>
            </template>

            <b-form @submit.prevent="search">
                <b-form-group
                    label="Search"
                    label-for="search"
                >
                    <b-input-group>
                        <b-form-input ref="search-term" type="search" v-model="search_term" />
                        <b-input-group-append>
                            <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                                <font-awesome-icon :icon="['fad', 'search']" />
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>
            <div class="btn btn-sm mb-3 btn-warning" @click="resetViewedArticles">
                reset viewed articles
            </div>
            <div v-if="searching" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>

            <div v-else>
                <b-list-group v-if="searched && filtered_articles && filtered_articles.length" class="mb-3">
                    <b-list-group-item v-for="(article, index) in filtered_articles" :key="index">
                        <div class="d-flex align-items-center">
                            <div>
                                <span
                                    class="mr-1 cursor-pointer"
                                    :class="articleWasViewed(article) ? 'viewed' : 'not-viewed'"
                                    @click="showArticlePreview(article)"
                                >
                                    {{article.title}}
                                </span>
                            </div>
                            <div class="ml-auto">
                                <div class="d-flex align-items-center">
                                    <div
                                        v-if="filter_type == 'activity'"
                                        class="text-info mr-3"
                                    >
                                        Activity
                                    </div>
                                    <div
                                        v-if="linkedToPage(article)"
                                        class="mr-3"
                                        content="Linked Page"
                                        v-tippy="{placement: 'top'}"
                                    >
                                        <b-badge variant="secondary">{{linkedToPage(article)}}</b-badge>
                                    </div>
                                    <div class="row">
                                        <b-form-checkbox
                                            class="text-center mr-5"
                                            size="sm"
                                            :checked="articleWasViewed(article)"
                                            @change="updateViewedArticles(article)"
                                            switch
                                        >
                                        </b-form-checkbox>
                                        <div v-if="articleLinkedToPage(article)">
                                            <b-link href="#" class="text-warning" @click.prevent="unlinkArticle(article)">
                                                <!-- <font-awesome-icon :icon="['fad', 'unlink']" /> -->
                                                Remove
                                            </b-link>
                                        </div>
                                        <div v-else-if="articleLinkedToUnit(article)">
                                            <b-link href="#" class="text-warning" @click.prevent="relinkArticle(article)">
                                                <!-- <font-awesome-icon :icon="['fad', 'exchange']" /> -->
                                                Add Back
                                            </b-link>
                                        </div>
                                        <div v-else>
                                            <b-link href="#" @click.prevent="linkArticle(article)">
                                                <!-- <font-awesome-icon :icon="['fad', 'link']" /> -->
                                                Add
                                            </b-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-collapse v-model="article.visible">
                            <div class="mt-3">
                                <div class="alert alert-info row">
                                    <div class="col">SKU: {{ article.sku }}</div><div v-if="article.is_trunk == 1" class="col"> TRUNK </div><div v-if="article.is_trunk != 1" class="col"> NON TRUNK </div><div class="col">Week: {{ article.week_number }}</div> <div class="col">Page: {{ article.page }}</div>
                                </div>
                                <div>
                                    <label>Article Body</label>
                                    <div v-if="article.body" v-html="article.body" class="border rounded p-3 v-html"></div>
                                    <div v-else class="text-danger">no article body</div>
                                </div>
                                <div class="mt-3">
                                    <label>Lexile</label>
                                    <div>
                                        <div v-if="article.lexile_api_score">{{article.lexile_api_score}}</div>
                                        <div v-else>0</div>
                                    </div>
                                </div>
                                <div v-if="article.lexile_certified_score" class="mt-3">
                                    <label>Lexile Certified Score</label>
                                    <div class="border-left pl-3">{{article.lexile_certified_score}}</div>
                                </div>
                            </div>
                        </b-collapse>
                    </b-list-group-item>
                </b-list-group>

                <b-alert
                    variant="danger"
                    :show="searched && (!filtered_articles || filtered_articles && !filtered_articles.length)"
                >
                    0 results
                </b-alert>
            </div>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
            </template>
        </b-modal>

         <article-modal
            v-model="show_article_modal"
            :article_id="selected_article_id"
            @hide="show_article_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>
.cursor-pointer {
    cursor: pointer;
}
.not-viewed{
    color: blue;
}
.viewed{
    color: purple;
}
</style>

<script>
import { mapState } from 'vuex'
import ArticleModal from '@/components/modals/article/ArticleModal'

export default {
    data: () => ({
        articles: [],
        filter_type: null,
        search_term: '',
        searching: false,
        searched: false,
        show_article_modal: false,
        selected_article_id: null,
        viewed_articles: [],
        updating_viewed_status: false,
    }),
    props: [
        'value',
        'unit',
        'page',
        'page_articles',
        'type',
        'trunkArticlesOnly',
        'publication'
    ],
    components: {
        ArticleModal
    },
    computed: {
        ...mapState({

        }),
        modal_id () {
            let modal_id = 'article-picker-modal'
            return modal_id
        },
        filtered_articles () {
            let filtered_articles = _.filter(this.articles, article => {
                if (this.filter_type) {
                    if (
                        this.filter_type == 'activity' &&
                        article.is_activity
                    ) {
                        return article
                    }
                    if (
                        this.filter_type == 'walkthrough' &&
                        article.is_walkthrough
                    ) {
                        return article
                    }
                    if (
                        this.filter_type == 'rubric' &&
                        article.is_rubric
                    ) {
                        return article
                    } 
                    else if (
                        this.filter_type == 'article' &&
                        !article.is_activity && 
                        !article.is_walkthrough && 
                        !article.is_rubric
                    ) {
                        return article
                    }
                } else {
                    return article
                }
            })

            return filtered_articles
        }
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    if (this.type) {
                        this.filter_type = this.type
                    }
                }
            }
        },
    },
    methods: {
        articleWasViewed(article){
            return this.viewed_articles.includes(article.id);
        },
        updateViewedArticles(article){
            this.updating_viewed_status = true;
            const index = this.viewed_articles.indexOf(article.id);
            if(index !== -1){
                this.viewed_articles.splice(index, 1);
                this.updating_viewed_status = false;
            }
            else{
                this.viewed_articles.push(article.id);
                this.updating_viewed_status = false;
            }
        },
        resetViewedArticles(){
            this.viewed_articles = [];
        },
        showArticlePreview(article) {
            this.viewed_articles.push(article.id);
            this.selected_article_id = article.id
            this.show_article_modal = true
        },
        search () {
            this.searching = true
            this.searched = false

            this.axios.get('/api/articles/search/' + this.search_term +'/'+ this.trunkArticlesOnly)
            .then(response => {
                if (response.data) {
                    this.articles = response.data

                    this.searching = false
                    this.searched = true
                }
            })
            .catch(error => {
                if (error) {
                    this.searching = false
                    this.searched = false
                }
            })
        },
        linkArticle (article) {
            this.$emit('Trunklink', article)
        },
        unlinkArticle (article) {
            this.$emit('unlink', article)
        },
        relinkArticle (article) {
            this.$emit('relink', article)
        },
        articleLinkedToPage (article) {
            let articleLinked = false

            if (_.find(this.page_articles, {article_id: article.id})) {
                articleLinked = true
            }

            return articleLinked
        },
        articleLinkedToUnit (article) {
            let articleLinked = false

            if (_.find(this.unit.articles, {article_id: article.id})) {
                articleLinked = true
            }

            return articleLinked
        },
        linkedToPage (article) {
            let page = null

            if (this.unit.articles) {
                _.forEach(this.unit.articles, unit_article => {
                    if (unit_article.article_id == article.id) {
                        page = unit_article.page
                    }
                })
            }

            return page
        },
        toggleArticleVisibility (article) {
            if (article.visible) {
                this.$set(article, 'visible', false)
            } else {
                this.$set(article, 'visible', true)
            }
        },
        focusSearchTerm () {
            if (this.$refs['search-term']) {
                this.$refs['search-term'].focus()
            }
        },
        resetForm(){
            this.articles = [];
            this.search_term = '';
        },
        cancel (event) {
            event.preventDefault()
            this.resetForm();
            this.$emit('hide')
        },
        hidden () {
            this.resetForm();
            this.$emit('hide')
        }
    }
}
</script>
